import {
  LeagueMemberRequest as SharedLeagueMemberRequest,
  LeagueMemberRequestStatus as SharedLeagueMemberRequestStatus,
  LEAGUE_MEMBER_REQUEST_STATUSES as SharedLeagueMemberRequestStatuses,
} from "shared/dist/types/LeagueMemberRequest";

export type LeagueMemberRequestStatus = SharedLeagueMemberRequestStatus;
export const LEAGUE_MEMBER_REQUEST_STATUSES = SharedLeagueMemberRequestStatuses;

export default interface LeagueMemberRequest extends SharedLeagueMemberRequest {}
